import { PaymentDetailsGeneralType } from '@/types/paymentDetailsTypes';
import { authApiService } from '../../authApiService';
import { ApiResponseType } from '@/types/sharedTypes';

export const getRecipientPaymentDetailsApi = (wireId: string): Promise<ApiResponseType<PaymentDetailsGeneralType>> => {
  const uri = `/recipient/wires/${wireId}/payment-details/`;

  return authApiService.GET(uri);
};
